import type { ReactNode } from "react";

/**
 * An empty state should say what will happen and how to start, not just report
 * absence — it is often the first thing a new partner admin sees.
 */
export function EmptyState({
	title,
	description,
	action,
}: { title: string; description: string; action?: ReactNode }) {
	return (
		<div className="flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-divider bg-surface2 px-6 py-14 text-center">
			<p className="text-title2 font-semibold text-heading">{title}</p>
			<p className="max-w-sm text-body text-muted-foreground">{description}</p>
			{action ? <div className="mt-3">{action}</div> : null}
		</div>
	);
}
